// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".communicationInput input{border:2px solid #3f9775;padding:0 5px}", ""]);
// Exports
exports.locals = {
	"green": "#3f9775",
	"white": "#fff"
};
module.exports = exports;
